import { doc } from 'firebase/firestore'
import { useEffect, useMemo } from 'react'
import { useDocumentData } from 'react-firebase-hooks/firestore'
import { documents } from '../../../constants/firestore'
import { db } from '../../../data/firebase'

/**
 * @typedef {Object} UseAuctionReturn
 * @property {boolean} loading
 * @property {Auction} auction
 *
 * @param {string} auctionId
 * @returns {UseAuctionReturn} - Auction data with loading
 */
export const useAuction = auctionId => {
  const [auctionData, loading, error] = useDocumentData(doc(db, documents.AUCTIONS, auctionId))

  const auction = useMemo(
    () =>
      auctionData
        ? {
            ...auctionData,
            startDatePreBid: auctionData.startDatePreBid?.toDate() || null,
            endDatePreBid: auctionData.endDatePreBid?.toDate() || null,
            startDate: auctionData.startDate?.toDate() || null,
            auctionTimerStartAt: auctionData.auctionTimerStartAt?.toDate() || null,
            liveAuctionStartedAt: auctionData.liveAuctionStartedAt?.toDate() || null,
            liveAuctionEndedAt: auctionData.liveAuctionEndedAt?.toDate() || null,
          }
        : null,
    [auctionData]
  )

  useEffect(() => {
    if (error) {
      console.error(error)
    }
  }, [error])

  return { auction, loading }
}
